module.exports = __webpack_public_path__ + "img/1.3df8a726.jpg";